import { types } from '../../types/types';
import { handleErrorApi } from '../../helpers/randoms';
import { finishSpinner, startSpinner } from '../ui/spinner';
import PracticasAgrupadasService from '../../services/PracticasAgrupadasService';
import { startAlerta } from '../ui/alertas';

export const fetchGrupos = () => async (dispatch) => {
  try {
      dispatch(startSpinner());
      const response = await PracticasAgrupadasService.getGrupos();
      const body = await response.json();

      if (response.ok) {
          dispatch({
              type: types.practicasAgrupadasTraerGruposSuccess,
              payload: body
          });
      } else {
          throw body;
      }
      dispatch(finishSpinner());
  } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.practicasAgrupadasTraerGruposError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los grupos",
        "Ha ocurrido un error. Intente nuevamente"
      );
  }
};

export const fetchPracticasGrupo = (idGrupo) => async (dispatch) => {
  try {
      dispatch(startSpinner());
      const response = await PracticasAgrupadasService.getPracticasGrupo(idGrupo);
      const body = await response.json();

      if (response.ok) {
          dispatch({
              type: types.practicasAgrupadasTraerPracticasSuccess,
              payload: body
          });
      } else {
          throw body;
      }
      dispatch(finishSpinner());
  } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.practicasAgrupadasTraerPracticasError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
  }
};

export const buscarGrupo = (text) => (dispatch) =>{
  dispatch({
      type : types.practicasAgrupadasBuscarGrupo,
      payload : text
  });
};

export const buscarPractica = (text) => (dispatch) =>{
  dispatch({
      type : types.practicasAgrupadasBuscarPractica,
      payload : text
  });
};

export const modificarGrupo = (id, data) => async (dispatch) => {
  try {
      dispatch(startSpinner());
      const response = await PracticasAgrupadasService.putGrupo(id, data);
      const body = await response.json();

      if (response.ok) {
          dispatch(startAlerta("Grupo modificado correctamente", 'success', 'Comando Exitoso'))
          dispatch(finishSpinner());
          dispatch(fetchGrupos());
      } else {
          throw body;
      }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al modificar",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const agregarGrupo = (data) => async (dispatch) => {
  try {
      dispatch(startSpinner());
      const response = await PracticasAgrupadasService.postGrupo(data);
      const body = await response.json();

      if (response.ok) {
          dispatch(startAlerta("Grupo creado correctamente", 'success', 'Comando Exitoso'))
          dispatch(finishSpinner());
          dispatch(fetchGrupos());
      } else {
          throw body;
      }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al generar",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const addPracticaAgrupada = (practica) => async (dispatch, getState) => {
  dispatch(startSpinner());
  const { practicas } = getState().practicasAgrupadas;
  const newPracticas = [...practicas, practica];
  dispatch({
    type: types.practicasAgrupadasTraerPracticasSuccess,
    payload: newPracticas,
  });
  dispatch(finishSpinner());    
};

export const savePracticasGrupo = (idGrupo, data, handleCloseModal) => async (dispatch) => {  
  try {
    dispatch(startSpinner());
    const response = await PracticasAgrupadasService.postPracticasGrupo(idGrupo, data);
    const body = await response.json();

    if (response.ok) {
        dispatch(startAlerta("Prácticas modificadas correctamente", 'success', 'Comando Exitoso'))
        handleCloseModal&& handleCloseModal();
        dispatch(finishSpinner());
    } else {
        throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al modificar",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const deletePracticasGrupo = (idGrupo, data) => async (dispatch) => {  
  try {
    dispatch(startSpinner());
    const response = await PracticasAgrupadasService.deletePracticasGrupo(idGrupo, data);
    const body = await response.json();

    if (response.ok) {
        dispatch(startAlerta("Práctica eliminada correctamente", 'success', 'Comando Exitoso'))
        dispatch(finishSpinner());
        dispatch(fetchPracticasGrupo(idGrupo));
    } else {
        throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al eliminar",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const eliminarGrupo = (id) => async (dispatch) => {
  try {
      dispatch(startSpinner());

      const response = await PracticasAgrupadasService.deleteGtupo(id);
      const body = await response.json(); 

      if(response.ok){
          dispatch(startAlerta("Grupo eliminado correctamente", 'success', 'Comando Exitoso'))
          dispatch(finishSpinner());
          dispatch(fetchGrupos());
      }else{
          throw body; 
      }
  } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar",
        "Ha ocurrido un error. Intente nuevamente"
      );
  }
};